module.exports = __webpack_public_path__ + "img/before-round.f525681d.png";